export type ComparatorFamilyColor = "pastel-yellow" | "pastel-orange" | "pastel-green" | "pastel-pink" | "pastel-blue";

export interface ComparatorLink {
    name: string;
    url: string;
    icon: string;
}

export interface ComparatorFamily {
    slug: string;
    name: string;
    description: string;
    icon: string;
    color: ComparatorFamilyColor;
    links: ComparatorLink[];
}

export const COMPARATOR_FAMILIES: ComparatorFamily[] = [
    {
        slug: "emprunteur-immo",
        name: "Emprunteur & immo",
        description: "Divisez le coût de votre assurance de prêt et couvrez tout ce qui touche à votre bien : location, travaux, revente.",
        icon: "fa-shield-check",
        color: "pastel-yellow",
        links: [
            {name: "Assurance emprunteur", url: "/simulation-assurance-pret-immobilier", icon: "fa-house-laptop"},
            {name: "Assurance PNO", url: "/guide/assurance-habitation/comparateur-assurance-pno", icon: "fa-key-skeleton"},
            {name: "Loyer impayé", url: "/guide/assurance-loyer-impaye", icon: "fa-key"},
            {name: "Assurance habitation", url: "/guide/assurance-habitation", icon: "fa-house-chimney"},
            {name: "Dommages ouvrage", url: "/guide/assurance-dommages-ouvrage", icon: "fa-house-circle-check"},
            {name: "Garantie décennale", url: "/guide/pro/garantie-decennale", icon: "fa-trowel-bricks"},
            {name: "Vente immobilière", url: "/guide/immobilier", icon: "fa-buildings"},
        ],
    },
    {
        slug: "sante-prevoyance",
        name: "Santé & prévoyance",
        description: "Une complémentaire au bon prix et une protection pour vos proches face aux coups durs : décès, dépendance, accidents de la vie.",
        icon: "fa-heart",
        color: "pastel-orange",
        links: [
            {name: "Mutuelle santé", url: "/comparateur-mutuelle-sante", icon: "fa-heart"},
            {name: "Mutuelle expatrié", url: "/guide/mutuelle-sante/expatries", icon: "fa-plane"},
            {name: "Décès", url: "/guide/assurance-deces", icon: "fa-cross"},
            {name: "Dépendance", url: "/guide/assurance-dependance", icon: "fa-family"},
            {name: "Obsèques", url: "/guide/assurance-obseques", icon: "fa-tombstone"},
            {name: "GAV", url: "/guide/assurance-garantie-accidents-vie", icon: "fa-bone-break"},
            {name: "Assurance vie", url: "/guide/assurance-vie", icon: "fa-shield-check"},
            {name: "Accidents chômage", url: "/guide/assurance-chomage", icon: "fa-briefcase"},
        ],
    },
    {
        slug: "voyage-mobilite",
        name: "Voyage & mobilité",
        description: "Partir et se déplacer sereinement : frais médicaux, annulation, bagages et tous vos véhicules.",
        icon: "fa-plane",
        color: "pastel-green",
        links: [
            {name: "Assurance voyage", url: "/guide/assurance-voyage", icon: "fa-plane"},
            {name: "Assurance auto", url: "/guide/assurance-auto", icon: "fa-car"},
            {name: "Assurance moto", url: "/guide/assurance-moto", icon: "fa-motorcycle"},
            {name: "Assurance vélo", url: "/guide/assurance-loisirs/velo", icon: "fa-bicycle"},
            {name: "Assurance bateau", url: "/guide/assurance-bateau", icon: "fa-sailboat"},
        ],
    },
    {
        slug: "pret-immo-finances",
        name: "Prêt immo & finances",
        description: "Financer, renégocier, placer : les meilleurs taux et les bons produits d'épargne, comparés en toute indépendance.",
        icon: "fa-key",
        color: "pastel-pink",
        links: [
            {name: "Prêt immobilier", url: "/guide/pret-immobilier", icon: "fa-house"},
            {name: "Rachat crédit", url: "/guide/rachat-credit", icon: "fa-hand-holding-circle-dollar"},
            {name: "Crédit consommation", url: "/guide/credit-consommation", icon: "fa-dollar"},
            {name: "Plan épargne retraite", url: "/guide/per/meilleur", icon: "fa-money-bill-trend-up"},
            {name: "Bourse / Placement", url: "/guide/assurance-vie/placement", icon: "fa-chart-line"},
            {name: "Banque", url: "/guide/banque", icon: "fa-building-columns"},
            {name: "Impôts", url: "/guide/impots", icon: "fa-file-invoice-dollar"},
            {name: "SCPI", url: "/guide/epargne/scpi", icon: "fa-buildings"},
        ],
    },
    {
        slug: "autres-assurances",
        name: "Autres assurances",
        description: "Vie quotidienne et activité professionnelle : tout ce qui ne rentre pas dans une famille mais que l'on compare aussi.",
        icon: "fa-grid-2",
        color: "pastel-blue",
        links: [
            {name: "Assurance mobile", url: "/guide/assurance-mobile", icon: "fa-mobile"},
            {name: "Assurance juridique", url: "/guide/protection-juridique", icon: "fa-gavel"},
            {name: "Assurance loisirs", url: "/guide/assurance-loisirs", icon: "fa-futbol"},
            {name: "Assurance scolaire", url: "/guide/assurance-scolaire", icon: "fa-graduation-cap"},
            {name: "Assurance animaux", url: "/guide/assurance-chien-chat", icon: "fa-paw"},
            {name: "Responsabilité civile", url: "/guide/responsabilite-civile", icon: "fa-family"},
            {name: "RC professionnelle", url: "/guide/pro/responsabilite-civile", icon: "fa-user-tie"},
            {name: "Guide assurances pro", url: "/guide/pro", icon: "fa-briefcase"},
        ],
    },
];

export const COMPARATOR_PRODUCT_COUNT = COMPARATOR_FAMILIES.reduce((total, family) => total + family.links.length, 0);
